import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const userUrl = `${SERVER_API}/users`;

export const ADMINISTRATION_USER = {
  ...generateCrudEndpoints(`${userUrl}`),
  HISTORY(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${userUrl}/${id}/login-histories`,
    };
  },
  RECIPIENTS: {
    method: 'GET',
    url: `${userUrl}/recipients`,
  },
  INTERVAL_STATISTICS: {
    method: 'GET',
    url: `${userUrl}/interval-statistics`,
  } as IEndpointData,
  INTERVAL_STATISTICS_EXPORT: {
    method: 'GET',
    url: `${userUrl}/interval-statistics-export`,
  } as IEndpointData,
  HISTORY_LIST: {
    method: 'GET',
    url: `${userUrl}/login-histories`,
  },
  SHORT_LIST: {
    method: 'GET',
    url: `${userUrl}/short`,
  },
  TTP_INFO(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${userUrl}/${id}/household`,
    };
  },
  RESTORE(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${userUrl}/${id}/restore`,
    };
  },
};
